import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faCheck } from '@fortawesome/free-solid-svg-icons';

import IconUpload from '../assets/icon_upload.png';

const HomeworksTab = ({ courseDetails, downloadedFiles, handleDownload, handleUpload, isHomeworkExpired, fileInputRef }) => {
    const account = JSON.parse(localStorage.getItem("account"));
    const isAdmin = account?.is_admin === 1; // ตรวจสอบว่า is_admin เป็น 1 หรือไม่

    return (
        <div id="homeworks-list">
            {courseDetails?.homeworks?.length > 0 ? (
                courseDetails.homeworks
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((homework) => (
                        <div
                            key={homework.uid}
                            className="homeworks-list"
                            style={{
                                padding: '24px',
                                textAlign: 'left',
                                gap: '8px',
                                border: '1px solid #dddddd',
                                borderRadius: '16px',
                                display: 'flex',
                                background: '#f2f2f2',
                                marginBottom: '24px'
                            }}
                        >
                            <div style={{ width: '70%', boxSizing: 'border-box' }}>
                                <div style={{ display: 'flex', flexGrow: 1 }}>
                                    <p
                                        style={{
                                            margin: '0',
                                            wordWrap: 'break-word',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'normal',
                                            fontSize: '36px'
                                        }}
                                    >
                                        {homework.chapter}
                                    </p>
                                </div>
                                <div style={styles.downloadHW}>
                                    {homework.files.map((file) => (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}
                                            key={file.url}
                                        >
                                            <FontAwesomeIcon
                                                icon={downloadedFiles[file.url] ? faCheck : faDownload}
                                                style={{
                                                    color: downloadedFiles[file.url] ? 'green' : 'white',
                                                    background: downloadedFiles[file.url] ? '#2187304D' : '#44526E',
                                                    border: `2px solid ${downloadedFiles[file.url] ? '#218730' : '#44526E'}`,
                                                    borderRadius: '1000px',
                                                    fontSize: '21.26px',
                                                    padding: '10px',
                                                }}
                                            />
                                            <a
                                                href={file.url}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: '#000000',
                                                    fontSize: '24px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={() => handleDownload(file.url)}
                                            >
                                                {file.filename}
                                            </a>
                                        </div>
                                    ))}
                                </div>
                                <div>
                                    <p style={{ margin: '0', color: 'red' , padding:'8px 0'}}>
                                    {homework.timeleft ? (
                                        `เหลือเวลาส่งอีก ${homework.timeleft.days} วัน ${homework.timeleft.hours} ชั่วโมง ${homework.timeleft.minutes} นาที`
                                    ) : (
                                        'หมดเวลาส่งงาน'
                                    )}
                                    </p>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        accept=".pdf,.png,.jpeg,.jpg,.doc,.docx,.xls,.xlsx"
                                        onChange={() => handleUpload(homework.uid)}
                                    />
                                    {!isHomeworkExpired(homework.timeleft) && (
                                        <button
                                            onClick={() => fileInputRef.current.click()}
                                            style={{
                                                width: '100%',
                                                backgroundColor: '#44526E',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '64px',
                                                display: 'flex',
                                                cursor: 'pointer',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <img
                                                src={IconUpload}
                                                alt="icon_upload"
                                                style={{ width: '100%', maxWidth: '32px', marginRight: '8px' }}
                                            />
                                            <p style={{ fontSize: '24px', fontWeight: 'bold' }}>อัพโหลดการบ้าน</p>
                                            <p style={{ fontSize: '16px', marginLeft: '8px' }}>(.PDF .PNG .JPEG .Office)</p>
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div
                                style={{
                                    width: '30%',
                                    background: '#e1e1e1',
                                    border: '1px solid #cccccc',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    wordBreak: 'break-all',
                                    whiteSpace: 'normal',
                                }}
                            >
                                <p style={{ fontSize: '24px', color: '#44526E', fontWeight: '700', margin: '0' }}>
                                    ไฟล์ที่อัพโหลด
                                </p>
                                <hr />
                                <div style={{ maxHeight: '241px', overflowY: 'auto', boxSizing: 'border-box', height: '241px' }}>
                                    {homework.user_files?.length > 0 ? (
                                        homework.user_files.map((f, index) => (
                                            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <a
                                                    target="_blank"
                                                    href={f.url}
                                                    style={{ fontSize: '24px', color: 'black', textDecoration: 'none' }}
                                                >
                                                    • {f.filename}
                                                </a>
                                            </div>
                                        ))
                                    ) : (
                                        <p style={{ marginBottom: '24px', fontSize: '24px' }}>ยังไม่มีไฟล์ที่ถูกอัพโหลด</p>
                                    )}
                                </div>
                                
                                {isAdmin ? (
                                <div>
                                    <hr />
                                        <p style={{ color: '#218730', textAlign: 'right', margin: 0, fontWeight: 'bold' }}>
                                            {homework.total_score}
                                        </p>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <p style={{ color: 'black', textAlign: 'right', margin: 0 }}>คะแนนที่ได้</p>
                                            <p style={{ color: 'black', textAlign: 'right', margin: 0 }}>/ {homework.max_score}</p>
                                        </div>
                                    </div>
                                ) : (
                                   null
                                )}

                                </div>
                        </div>
                    ))
            ) : null}
        </div>
    );
};

const styles = {
    downloadHW:{
        border:'1px solid #dddddd',
        borderRadius:'16px',
        padding:'24px',
        height:'241px',
        maxHeight: '241px', overflowY: 'auto',
    },
}

export default HomeworksTab;
